import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate, Link, useLocation } from 'react-router-dom';
import style from '../../../css/Product.module.css';
import Cookies from 'js-cookie';
import { useSearchParams } from 'react-router-dom';
import html2canvas from 'html2canvas';

const Server = React.memo(({ server, onSelectedServer }) => {
    const [selectedProductId, setSelectedProductId] = useState(() => {
        const servercookie = Cookies.get("selectedServer");
        return servercookie ? parseInt(servercookie) : null;
    });
    const { t, i18n } = useTranslation();
    useEffect(() => {
        const language = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(language);
    }, [i18n]);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        const serverFromUrl = searchParams.get("server");

        if (serverFromUrl) {
            const parsedServerId = parseInt(serverFromUrl);

            const serverFromList = server.find((srv) => srv.id === parsedServerId);
            if (serverFromList) {
                setSelectedProductId(parsedServerId);
                onSelectedServer(serverFromList);
                // Cookies.set("selectedServer", parsedServerId, { expires: 7 });
            }
        } else if (server.length > 0) {
            const serverFromCookie = selectedProductId
                ? server.find((srv) => srv.id === selectedProductId)
                : null;

            if (serverFromCookie) {
                onSelectedServer(serverFromCookie);
            } else {
                const defaultServer = server[0];
                setSelectedProductId(defaultServer.id);
                onSelectedServer(defaultServer);
            }
        }
    }, [server, searchParams]);

    const handleProductClick = (pro) => {
        setSelectedProductId(pro.id);
        onSelectedServer(pro);
        // Cookies.set("selectedServer", pro.id, { expires: 7 });
    };

    const renderServices = () => {
        if (Array.isArray(server) && server.length > 0) {
            return server.map((pro) => (
                <div className="col-lg-3 col-md-4 col-sm-6 col-xxl-1-6" key={pro.id}>
                    <div
                        className={style.card}
                        onClick={() => handleProductClick(pro)}
                        // onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                        // onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                        style={{
                            position: 'relative',
                            border: selectedProductId === pro.id ? '2px solid rgba(59, 130, 246, 0.5)' : '1px solid #ccc',
                            borderRadius: '5px',
                            padding: '10px',
                            margin: '0 auto',
                            width: '100%',
                            // transition: 'all 0.3s ease',
                            backgroundColor: selectedProductId === pro.id ? 'rgba(59, 130, 246, 0.1)' : '#fff', // Thêm màu nền cho khung chọn
                        }}
                    >
                        <div>
                            <h5 style={{ margin: '0 auto', textAlign: 'center', color: '#333', height: "25px" }}>{pro.name}</h5>
                        </div>
                        <div
                            style={{
                                width: '40px',
                                height: '3px',
                                backgroundColor: selectedProductId === pro.id ? 'blue' : '#ccc',
                                margin: '10px auto',
                                transition: 'background-color 0.3s ease',
                            }}
                        ></div>
                        <div style={{
                            fontSize: "13px",
                            lineHeight: "1.5",
                            color: "#333",
                        }}>
                            {t("Information_server")}
                        </div>
                    </div>
                </div>
            ));
        } else {
            return <p>Không có sản phẩm</p>;
        }
    };

    return (
        <div className="container-fluid" style={{ padding: '0' }}>
            <div className="row g-3">{renderServices()}</div>
        </div>
    );
});

export default Server;
